import { Navigate, Outlet, useLocation } from "react-router-dom";

import PageLoader from "@/common/components/PageLoader";
import SessionExpiredOverlay from "@/common/components/SessionExpiredOverlay";
import { useAuth } from "@/common/hooks/useAuth";

export const AdminRoute = () => {
  const { isAuthenticated, isSuperAdmin, isAppReady, isUserDetailsLoading } =
    useAuth();
  const location = useLocation();

  if (isAuthenticated === null || !isAppReady || isUserDetailsLoading) {
    return <PageLoader />;
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to={`/login?returnUrl=${encodeURIComponent(location.pathname + location.search + location.hash)}`}
        replace
      />
    );
  }

  if (!isSuperAdmin) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <SessionExpiredOverlay />
      <Outlet />
    </>
  );
};
